import { render, staticRenderFns } from "./addMiniGameTemplate.vue?vue&type=template&id=7352cab6&lang=pug"
import script from "./addMiniGameTemplate.vue?vue&type=script&lang=js"
export * from "./addMiniGameTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports